export default __webpack_public_path__ + "static/media/Visitor.cc4d8c6d.jpg";